import HandymanIcon from '@mui/icons-material/Handyman';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { visuallyHidden } from '@mui/utils';
import { GridColDef, GridRenderCellParams, GridValidRowModel } from '@mui/x-data-grid';
import { TFunction } from 'i18next';
import { ReactNode } from 'react';

type ActionsRenderer<T extends GridValidRowModel> = (params: GridRenderCellParams<T>) => ReactNode;

export function actionsColumn<T extends GridValidRowModel>(
  t: TFunction,
  labelKey: string,
  renderActions: ActionsRenderer<T>,
  width = 120,
): GridColDef<T> {
  return {
    field: 'actions',
    type: 'actions',
    headerName: t(labelKey),
    width,
    minWidth: width,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    align: 'right',
    headerAlign: 'right',
    renderCell: params => (
      <Box
        onClick={e => e.stopPropagation()}
        onKeyDown={e => e.stopPropagation()}
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'flex-start',
          gap: 0.25,
          width: '100%',
          height: '100%',
        }}
      >
        {renderActions(params)}
      </Box>
    ),
  };
}

export function handymanActionsColumn<T extends GridValidRowModel>(
  t: TFunction,
  labelKey: string,
  renderActions: ActionsRenderer<T>,
  width = 52,
): GridColDef<T> {
  const label = t(labelKey);
  return {
    ...actionsColumn<T>(t, labelKey, renderActions, width),
    headerName: label,
    renderHeader: () => (
      <Tooltip title={label}>
        <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
          <HandymanIcon fontSize="small" aria-hidden />
          <Box component="span" sx={visuallyHidden}>
            {label}
          </Box>
        </Box>
      </Tooltip>
    ),
  };
}
